import React from "react";
import { Box, Chip } from "@mui/material";
import { VehicleFilters } from "../../hooks/useVehicleFilters";
import { FILTER_CHIP_CONFIG } from "./constants";

type ActiveFilterChipsProps = {
  filters: VehicleFilters;
  onRemoveFilter: (key: keyof VehicleFilters) => void;
};

function ActiveFilterChips({
  filters,
  onRemoveFilter,
}: ActiveFilterChipsProps) {
  const activeFilters = Object.entries(filters).filter(
    ([_, value]) => value !== null
  );

  if (activeFilters.length === 0) {
    return null;
  }

  return (
    <Box display="flex" gap={1} alignItems="center" flexWrap="wrap">
      {activeFilters.map(([key, value]) => {
        const filterKey = key as keyof VehicleFilters;
        const config = FILTER_CHIP_CONFIG[filterKey];

        if (!config) {
          return null;
        }

        return (
          <Chip
            key={key}
            label={config.getLabel(value)}
            onDelete={() => onRemoveFilter(filterKey)}
            color="primary"
            size="small"
          />
        );
      })}
    </Box>
  );
}

export default ActiveFilterChips;
